import axios from "axios";
import ApiService from "./ApiService";

const ReceivableService = {
  getAll: async () => {
    return ApiService.get("receivables/v1/receivables", { pageSize: 9999999 });
  },

  uploadFile: async (file) => {
    const POST_URL =
      process.env.REACT_APP_DELEND_API + "/receivables/v1/receivables";

    const onUploadProgress = (progressEvent) => {
      const { loaded, total } = progressEvent;

      let percent = Math.floor((loaded * 100) / total);

      if (percent < 100) {
        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
      }
    };

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("user-token");

    return axios.post(POST_URL, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  },
};

export default ReceivableService;
